var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathtubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49475 10.9852V12.483",
    stroke: "#3D536C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4843 10.9852V12.483",
    stroke: "#3D536C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49597 5.49332V2.24814C3.49597 1.91712 3.62747 1.59965 3.86154 1.36557C4.09562 1.1315 4.41309 1 4.74412 1C5.07514 1 5.39262 1.1315 5.62669 1.36557C5.86076 1.59965 5.99226 1.91712 5.99226 2.24814",
    stroke: "#3D536C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4828 4.9939H8.48877V7.98944H12.4828V4.9939Z",
    stroke: "#3D536C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4828 5.49341H14.4798C14.6123 5.49341 14.7392 5.54601 14.8329 5.63964C14.9265 5.73327 14.9791 5.86025 14.9791 5.99267V7.9897C14.9791 8.78417 14.6635 9.5461 14.1017 10.1079C13.5399 10.6696 12.778 10.9852 11.9835 10.9852H3.99542C3.20096 10.9852 2.43903 10.6696 1.87725 10.1079C1.31548 9.5461 0.999878 8.78417 0.999878 7.9897V5.99267C0.999878 5.86025 1.05248 5.73327 1.14611 5.63964C1.23974 5.54601 1.36672 5.49341 1.49914 5.49341H8.48874",
    stroke: "#3D536C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtubIcon);
export default __webpack_public_path__ + "static/media/bathtub-icon.0d5af4ce7dacabbf4cca5d256962a6f7.svg";
export { ForwardRef as ReactComponent };